import apiWorker from '../apiWorker'

export default {

    create: (data) => apiWorker('post', `/api/v1/billing/payment_event_logs/create`, data),

}
